export default __webpack_public_path__ + "static/media/pdf.6d2a28bb.svg";